/**
 * `/connect/mock/$ref` — search schema.
 *
 * The mock processor has no hosted onboarding form of its own (PAY-1 review round 3,
 * finding 1): `lib/payments/provider-mock.ts`'s `createAccountLink()` mints
 * `url: /connect/mock/${accountRef}` for a seller's "Set up where you get paid" click on
 * `/market/sell` — the SAME shape `createCheckout()` already uses for a buyer's checkout
 * (see `checkout.mock.$ref.tsx`, this route's sibling), and it was unrouted for the exact
 * same reason: nobody had built the honest local page the comment on `createAccountLink()`
 * implies. A seller who clicked "Open the processor's form" landed on the router's
 * catch-all "Not Found" after a real `seller_payout_accounts` row had already been
 * created server-side — the seller's half of the identical defect PAY-1 was written to
 * close on the buyer's half.
 *
 * DELIBERATELY NOT UNDER `/market` (same reasoning `checkout.mock.$ref.tsx` gives for
 * itself): a seller reaching this page is already past `routeStageGate('sellerProfile')`
 * on the server, but the PAGE itself needs no marketplace build flag to render — it reads
 * nothing and writes nothing, it only tells the seller what to do next. Living directly
 * under `/checkout`'s sibling `/connect`, both children of the pathless `_authenticated`
 * layout, answers to no feature gate but being signed in.
 *
 * The ref is not validated or looked up here, for the same reason `checkout.mock.$ref.tsx`
 * does not look up its own: it is a webhook/processor-side lookup key, and turning it into
 * a second, browser-reachable lookup key for "whose seller account is this" is a new
 * attack surface this fix does not need to open. This screen sends the seller back to
 * `/market/sell`, the same `?connect=return` destination
 * `startSellerPayoutOnboarding()` (`marketplace-routes.ts`) already names as the real
 * processor's own `returnUrl` — the page that reads the account's actual connect status
 * from the server is the honest answer to "did it work", not this one.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/connect/mock/$ref')({});
